// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231236/js/" + chunkId + "." + {"44":"9e37b653","225":"9ab8dfb3","481":"2fddef4f","486":"6f5c0dc4","770":"92a60da0"}[chunkId] + ".0.562804936582623.chunk.js";
};